import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../../constants';

const SHOT_SHADOW = '0 1px 2px rgba(6, 63, 69, 0.06), 0 16px 40px rgba(6, 63, 69, 0.12)';
const SHOT_SHADOW_ON_DARK = '0 18px 44px rgba(0, 0, 0, 0.28)';

const useStyles = makeStyles(() => ({
    panel: {
        boxSizing: 'border-box',
        display: 'grid',
        placeItems: 'center',
        padding: 'clamp(12px, 1.8vw, 22px)',
        borderRadius: '20px',
    },
    shot: {
        position: 'relative',
        width: '100%',
        aspectRatio: '16 / 9',
        overflow: 'hidden',
        borderRadius: '12px',
        background: REDESIGN_COLORS.white,
        boxShadow: SHOT_SHADOW,
        // Lets a drawn mock inside size its type in `cqw` against this frame.
        containerType: 'inline-size',
    },
    shotOnDark: {
        boxShadow: SHOT_SHADOW_ON_DARK,
    },
    image: {
        display: 'block',
        width: '100%',
        height: '100%',
    },
    // Where the design has no screenshot yet: the frame keeps its place and
    // says what belongs in it.
    placeholder: {
        boxSizing: 'border-box',
        display: 'grid',
        placeItems: 'center',
        height: '100%',
        padding: '24px',
        color: REDESIGN_COLORS.muted,
        fontSize: '0.9rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
        textAlign: 'center',
        background: `repeating-linear-gradient(to bottom, ${REDESIGN_COLORS.white} 0 28px, #F0EFE9 28px 29px)`,
    },
}));

/**
 * The tinted media panel used throughout the tools section: a 16:9 white frame
 * on a soft-coloured mat. Shows `src` when there is a screenshot, `children`
 * for a drawn mock, and a labelled empty frame otherwise.
 */
const FeatureMedia = ({
    tint,
    src,
    alt,
    fit = 'contain',
    position = 'center',
    onDark = false,
    placeholder,
    children,
    // Every screenshot in /redesign is 1600x900; the attributes reserve the
    // box before the image loads so the page does not shift.
    width = 1600,
    height = 900,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.panel} style={{ background: onDark ? 'rgba(255, 255, 255, 0.07)' : tint }}>
            <div className={[classes.shot, onDark ? classes.shotOnDark : ''].filter(Boolean).join(' ')}>
                {children ? (
                    children
                ) : src ? (
                    <img
                        src={src}
                        alt={alt}
                        width={width}
                        height={height}
                        loading="lazy"
                        decoding="async"
                        className={classes.image}
                        style={{ objectFit: fit, objectPosition: position }}
                    />
                ) : (
                    <div className={classes.placeholder}>{placeholder}</div>
                )}
            </div>
        </div>
    );
};

export default FeatureMedia;
